import Axios from 'axios'

export default {
  data() {
    return {
      mixin: {
        activityList: [],
      },
      condition: {
        activityRandom: null,
        startTime: null,
        endTime: null,
      },
      table: {
        pageNo: 1,
        pageSize: 20,
      }
    }
  },
  created() {
    this.fetchActivitylist();
  },
  computed: {
    datePickers() {
      if (
        this.condition.startTime === null ||
        this.condition.endTime === null
      ) {
        return []
      }
      return [this.condition.startTime, this.condition.endTime]
    },
  },
  methods: {
    async fetchActivitylist() {
      const res = await Axios.get(
        '/lxs/platform_customerflow/get_available_act',
      )
      if (res.data.status === 200) {
        const activityList = Object.keys(res.data.data).map(key => Object.freeze({
          label: res.data.data[key],
          value: key
        }))
        this.mixin.activityList.push(...activityList);
      }
    },
    datePickerChange(dates) {
      const { minDate, maxDate } = dates
      if (minDate && maxDate) {
        this.condition.startTime = this.formatDate(minDate)
        this.condition.endTime = this.formatDate(maxDate)
      }
    },
    formatDate(date) {
      if (!date) {
        return date
      }
      const dateArr = date
        .toLocaleDateString()
        .split('/')
        .map((item) => item.padStart(2, '0'))
      return dateArr.join('-')
    },
  }
}